import { Component } from '@theme/component';

class HeroVideoBackground extends Component {
  requiredRefs = ['videoElement', 'videoSources'];

  /** Project mobile → desktop breakpoint (see .claude/rules/03-responsive-mobile.md). */
  static desktopQuery = '(min-width: 750px)';

  /** @type {MediaQueryList | null} */
  #desktop = null;

  connectedCallback() {
    super.connectedCallback();

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (this.dataset.disableMobile !== 'true') {
      this.#load();
      return;
    }

    this.#desktop = window.matchMedia(HeroVideoBackground.desktopQuery);

    if (this.#desktop.matches) {
      this.#load();
      return;
    }

    this.#desktop.addEventListener('change', this.#handleViewportChange);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#desktop?.removeEventListener('change', this.#handleViewportChange);
  }

  /** @param {MediaQueryListEvent} event */
  #handleViewportChange = (event) => {
    if (!event.matches) return;

    this.#desktop?.removeEventListener('change', this.#handleViewportChange);
    this.#load();
  };

  #load() {
    if (this.dataset.loaded === 'true') return;

    const { videoElement, videoSources } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }

    this.dataset.loaded = 'true';
    videoElement.load();
  }
}

if (!customElements.get('hero-video-background')) {
  customElements.define('hero-video-background', HeroVideoBackground);
}
